module.exports = "<div seedelement class=\"lui-interactive\">\n  <slot></slot>\n  <span class=\"lui-overflow__button\">\n    <svg class=\"lui-overflow__icon\" viewBox=\"0 -1 4 20\" version=\"1.1\">\n      <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <circle class=\"lui-overflow__dot\" cx=\"2\" cy=\"2\" r=\"2\"></circle>\n        <circle class=\"lui-overflow__dot\" cx=\"2\" cy=\"9\" r=\"2\"></circle>\n        <circle class=\"lui-overflow__dot\" cx=\"2\" cy=\"16\" r=\"2\"></circle>\n      </g>\n    </svg>\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-overflow/theme/lui-overflow.html
// module id = 283
// module chunks = 0 1 29